import React from 'react';
import AssetPreview from '../components/preview/AssetPreview';

export default function PreviewPage() {
  return <AssetPreview />;
}